import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ModalDialog, Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { Field, reduxForm } from "redux-form";
import LocaleStrings from "Languages";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import { fetchClientalldetails, updateClientdata } from "AccountSettingsAction";
import {
  COMMON_FAIL_MESSAGE,
} from "Constants";

class EditbillingdetailsModal extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      btnLoading: false
    };
  }

  closeModals = () => {
    this.props.onClose();
  };

  onSubmitForm = (values) => {
    let { session } = this.props;
    this.setState({ loading: true });
    this.props.updateClientdata(this.props.session, values, (response) => {
      if (response.success === 0) {
        this.setState({ loading: false });
        this.props.showError(COMMON_FAIL_MESSAGE);
      } else {
        this.props.fetchClientalldetails(
          this.props.session,
          this.props.user.clientid,
          (CallBackResponse) => {
            this.setState({ loading: false });
            this.props.onClose();
            this.props.showSuccess('Report Added successfully');
          }
        );
      }
    });
  };


  render() {
    let { initialValues, handleSubmit ,allcountryList} = this.props;
    // console.log('ini',initialValues);
    let countryOpts = [];
    _.forEach(allcountryList, function (value) {
      var obj = {
        name: value.name,
        value: value.value,
      };

      countryOpts.push(obj);
    });
    return (
      <Modal
        show={this.props.isOpen}
        onHide={this.closeModals}
        className=""
        dialogClassName="contact-eventify-modal"
      >
        <form onSubmit={handleSubmit(this.onSubmitForm)}>
          <Modal.Header >
            <Modal.Title>
              <div className="title-modal">{LocaleStrings.accountsetting_billingdetails_subheader_editbilling_account} for - {initialValues.email}</div>
            </Modal.Title>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={this.closeModals}
            >
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-6">
                <Field
                  name="firstname"
                  label={LocaleStrings.user_form_label_firstname}
                  placeholder={LocaleStrings.user_form_label_firstname}
                  type="text"
                  component={this.renderFieldText}
                  mandatory="true"
                  labelposition={LABEL_POSITION_TOP}
                />
              </div>
              <div className="col-md-6">
                <Field
                  name="lastname"
                  label={LocaleStrings.user_form_label_lastname}
                  placeholder={LocaleStrings.user_form_label_lastname}
                  type="text"
                  component={this.renderFieldText}
                  mandatory="true"
                  labelposition={LABEL_POSITION_TOP}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Field
                  name="address"
                  label="Address"
                  placeholder="address"
                  type="text"
                  component={this.renderFieldText}
                  mandatory="true"
                  labelposition={LABEL_POSITION_TOP}
                />
              </div>
              <div className="col-md-6">
                {/* <Field
                  name="email"
                  label={LocaleStrings.user_form_label_email}
                  placeholder={LocaleStrings.user_form_label_email}
                  type="email"
                  component={this.renderFieldText}
                  mandatory="true"
                  labelposition={LABEL_POSITION_TOP}
                /> */}
                {/* <Field
                  name="state"
                  label="State"
                  placeholder="state"
                  type="text"
                  component={this.renderFieldText}
                  mandatory="true"
                  labelposition={LABEL_POSITION_TOP}
                /> */}
                  <Field
                  name="country"
                  label="Select Country"
                  placeholder="Select Country"
                  component={this.renderSelect}
                  opts={countryOpts}
                  labelposition={LABEL_POSITION_TOP}

                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Field
                  name="city"
                  label="City"
                  placeholder="State"
                  type="text"
                  component={this.renderFieldText}
                  mandatory="true"
                  labelposition={LABEL_POSITION_TOP}
                />
              </div>
              <div className="col-md-6">
                <Field
                  name="zipcode"
                  label="Zip Code"
                  placeholder="zip code"
                  type="text"
                  component={this.renderFieldText}
                  mandatory="true"
                  labelposition={LABEL_POSITION_TOP}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Field
                  name="vat_number"
                  label="Vat Number"
                  placeholder="vat number"
                  type="text"
                  component={this.renderFieldText}
                  mandatory="true"
                  labelposition={LABEL_POSITION_TOP}
                />
              </div>
              <div className="col-md-6">
                <Field
                  name="companyname"
                  label="Company Name"
                  placeholder="company name"
                  type="text"
                  component={this.renderFieldText}
                  labelposition={LABEL_POSITION_TOP}
                />
              </div>
            </div>
            {/* <div className="row">
              <div className="col-md-6">
                <Field
                  name="companyname"
                  label="Company Name"
                  placeholder="company name"
                  type="text"
                  component={this.renderFieldText}
                  labelposition={LABEL_POSITION_TOP}
                />
              </div>
            </div> */}
          </Modal.Body>
          <Modal.Footer>
            <div>
              <div className="pull-left h-100 vertical-align-center">
              </div>
              <div className="pull-right h-100 vertical-align-center" style={{ marginLeft: 'auto' }}>
                <Button variant="secondary" onClick={this.closeModals}>
                  {LocaleStrings.accountsetting_billingdetails_contacteventify_modalclose}
                </Button>
                <Button
                  className="btn-custom-blue"
                  loading={this.state.loading}
                  type="submit"
                  style={{ marginLeft: '10px' }}
                >
                  {LocaleStrings.accountsetting_billingdetails_contacteventify_modalsave}
                </Button>
              </div>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

function validate(values) {
  // console.log('values',values);
  var errors = {};
  var requiredFields = [
    "firstname",
    "lastname",
    "address",
    "email",
    "city",
    "zipcode",
  ];
  requiredFields.forEach((field) => {
    if (!values[field] || values[field] === "") {
      errors[field] = "Required";
    }
  });
  return errors;
}
function mapStateToProps(state) {
  return {
    session: state.session,
    user: state.user,
    initialValues: state.clientdataforbilling ? state.clientdataforbilling[0] : {},
    allcountryList:state.allcountryList
  };
}
export default connect(mapStateToProps, {
  fetchClientalldetails,
  updateClientdata
})(
  reduxForm({
    validate,
    form: "EditbillingdetailsModalForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(EditbillingdetailsModal)
);